import { View, Text, ViewStyle } from 'react-native';
import amplitude from 'src/_shared/amplitude';
import { useStore } from 'src/contexts/StoreContext';
import { styles } from './BottomSheetUpselling.style';
import Video from 'react-native-video';
import { modalTestID } from 'src/helpers/testIDs.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { SecondaryButton } from '../buttons/secondary-button/SecondaryButton';
import { PrimaryButton } from '../buttons/primary-button/PrimaryButton';
import { getFormattedPrice } from 'src/helpers/price.helper';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { BottomSheetScrollView } from '@gorhom/bottom-sheet';

const BottomSheetUpselling = ({ bsStyle }: { bsStyle: ViewStyle }) => {
  const {
    project: { activeProduct },
    bottomSheet: { bottomSheetData, closeBottomSheet, onPressDiscardChanges, onPressSaveChanges },
  } = useStore();
  const upsellingData = bottomSheetData.upsellingData[0];

  const handleDiscadButton = async () => {
    amplitude.trackEvent(AnalyticsEvents.upselling.declined);
    onPressDiscardChanges();
    closeBottomSheet();
  };
  const handleConfirmButton = async () => {
    amplitude.trackEvent(AnalyticsEvents.upselling.accepted, {
      current_product_id: activeProduct.id,
      new_product_id: upsellingData.upsellingProductId,
      proposed_price: upsellingData.prices.upsellingPublicUnitPrice,
      title: upsellingData.eventCode,
    });
    onPressSaveChanges();
    closeBottomSheet();
  };

  return (
    <BottomSheetScrollView contentContainerStyle={bsStyle}>
      <View style={styles.wrapper}>
        <View style={styles.headerContainer}>
          <View style={styles.titleContainer}>
            <Text style={styles.title}>{upsellingData.header}</Text>
            <Text>{'+' + getFormattedPrice({ price: upsellingData.prices.difference })}</Text>
          </View>
          <Text>{upsellingData.description}</Text>
        </View>
        <View style={styles.videoContainer}>
          <Video
            source={{
              uri: upsellingData.galleryItems[0].value.url,
            }}
            repeat={upsellingData.galleryItems[0].value.loop}
          />
        </View>
        <View style={styles.ctaContainer}>
          <SecondaryButton
            onPress={handleDiscadButton}
            text={upsellingData.denyCta}
            testID={modalTestID(TestIDs.UPSELLING, TestIDs.DISCARD)}
            focusId={modalTestID(TestIDs.UPSELLING, TestIDs.DISCARD)}
            focusOrder={1}
            focusGroup={FocusGroups.MODAL}
          />
          <PrimaryButton
            onPress={handleConfirmButton}
            text={upsellingData.confirmCta}
            testID={modalTestID(TestIDs.UPSELLING, TestIDs.CONFIRM)}
            focusId={modalTestID(TestIDs.UPSELLING, TestIDs.CONFIRM)}
            focusOrder={0}
            focusGroup={FocusGroups.MODAL}
          />
        </View>
      </View>
    </BottomSheetScrollView>
  );
};

export default BottomSheetUpselling;
